import fa from './fa';
import en from './en';
import type { SiteLanguage } from '../types/region';

const dictionaries = { fa, en } as const;

export type TranslationKey =
  | `nav.${keyof typeof fa.nav}`
  | `hero.${keyof typeof fa.hero}`
  | `games.${keyof typeof fa.games}`
  | `video.${keyof typeof fa.video}`
  | `search.${keyof typeof fa.search}`
  | `footer.${keyof typeof fa.footer}`
  | `notFound.${keyof typeof fa.notFound}`
  | `download.${keyof typeof fa.download}`
  | `media.${keyof typeof fa.media}`
  | `common.${keyof typeof fa.common}`;

function getNested(obj: Record<string, unknown>, path: string): string | undefined {
  const parts = path.split('.');
  let cur: unknown = obj;
  for (const p of parts) {
    if (cur == null || typeof cur !== 'object') return undefined;
    cur = (cur as Record<string, unknown>)[p];
  }
  return typeof cur === 'string' ? cur : undefined;
}

export function createTranslator(language: SiteLanguage) {
  const dict = dictionaries[language] || dictionaries.fa;
  return function t(key: TranslationKey | string, fallback?: string): string {
    const val = getNested(dict as Record<string, unknown>, key);
    if (val !== undefined) return val;
    // Fallback to English dictionary if not found in current dict
    const enVal = getNested(dictionaries.en as Record<string, unknown>, key);
    if (enVal !== undefined) return enVal;
    return fallback ?? key;
  };
}

export { fa, en };
